<template>
  <v-app style="background: #000">
    <v-content>
      <transition name="company">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </v-content>

       <a v-if="updateExists" href="#" class="banner banner--gradient-bg">
        <div class="banner__logo-wrapper">
          <i class="fi fi-codepen"></i>
        </div>
        <div>
          <div class="banner__text">New version available!</div>
        </div>
        <div @click="refreshApp" class="banner__cta">
          Click to update
        </div>
      </a>

     <l-app-bar></l-app-bar>
  </v-app>
</template>

<script>
import lAppBar from "@/components/appBar";
import NewContentAvailableToastr from '@/components/NewContentAvailableToastr'
import AppleAddToHomeScreenModal from '@/components/AppleAddToHomeScreenModal'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    lAppBar,
    NewContentAvailableToastr,
    AppleAddToHomeScreenModal
  },
  data() {
    return {
      transitionName: null,
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  computed: {
    ...mapGetters('app', ['newContentAvailable']),
    ...mapState('app', ['showAddToHomeScreenModalForApple', 'refreshingApp'])
  },
  methods: { ...mapActions('app', [
    'closeAddToHomeScreenModalForApple',
    'serviceWorkerSkipWaiting'
  ]),
  showRefreshUI (e) {
  this.registration = e.detail;
  this.updateExists = true;
},
  refreshApp () {
  this.updateExists = false;
  if (!this.registration || !this.registration.waiting) { return; }
  this.registration.waiting.postMessage('skipWaiting');
    },
  },
  created () {
    this.$store.commit('app/SET_APPVERSION', '0.5.4')
document.addEventListener(
    'swUpdated', this.showRefreshUI, { once: true }
  );
  navigator.serviceWorker.addEventListener(
    'controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    }
  );


  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.transitionName = toDepth < fromDepth ? "slide-right" : "company";
    }
  }
};
</script>


<style lang="scss">
body {
  margin: 0;
  a {
    font-weight: 500;
    text-decoration: none;
  }
  #app {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    color: #2c3e50;
    .new-content-available-toastr {
      position: absolute;
      bottom: 10px;
      right: 10px;
      z-index: 999999;
    }
    .apple-add-to-home-screen-modal {
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      height: fit-content;
      width: fit-content;
      margin: auto;
      z-index: 1000;
    }
    .main-wrapper {
      margin-top: 3.6rem;
      padding: 20px;
      .page-wrapper {
        width: 60%;
        margin: auto;
        @media screen and (max-width: 1000px) {
          width: 100%;
        }
      }
    }
  }
}


.banner{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 90px;
  right: -4px;
  margin: 10px;  
  padding: 0.8rem;
  border-radius: 5px;
  color: #D60509;
  font-weight: 500;
  width: 320px;
  height: 60px;
  z-index: 9999;
}
.banner--gradient-bg {
  background: #FCE8E6;
}
.banner .banner__cta {
  display: flex;
  margin-left: 2px;
  padding: 6px;
  background: #FFBD2E;
  color: #000;
  border-radius: 4px;
}

</style>